import {authHeader, ApiConfigs} from "../_helpers";

export const categoryService = {
    getAll,
    getAllWithProducts,
    show,
    add,
    delete: _delete,
    update,
    filter,
    updateConfig
};

function getAll(param: any = "") {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.getAll + param}`, requestOptions)
        .then(
            handleResponse
        );
}


function getAllWithProducts(param: any = "") {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.getAll + param}&append=products`, requestOptions)
        .then(
            handleResponse
        );
}


function filter(payload:object) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.getAll}`, requestOptions)
        .then(
            handleResponse
        );
}

function show(id: string) {
    const requestOptions = {
        method: "GET",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" }, 
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.show.replace(':id', id)}`, requestOptions)
        .then(
            handleResponse
        );
}

function add(payload:object ){
    const requestOptions = {
        method: "POST",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.add}`, requestOptions)
        .then(
            handleResponse
        );
}

function _delete(id: string){
    const requestOptions={
        method:"DELETE",
        credentials : 'include' as RequestCredentials,
        headers: { "Content-Type": "application/json" },

    }

    return fetch(`${ApiConfigs.base_url+ApiConfigs.category.delete.replace(':id', id)}`, requestOptions)
        .then(handleResponse);
}

function update(id: string, payload: object){
    const requestOptions={
        method:"PUT",
        credentials : 'include' as RequestCredentials,
        headers: { ...authHeader(), "Content-Type": "application/json" },
        body: JSON.stringify(payload)
    }

    return fetch(`${ApiConfigs.base_url+ ApiConfigs.category.update.replace(':id', id)}`, requestOptions)
    .then(handleResponse);
}

function updateConfig(payload:any ){

    const requestOptions = {
        method: "POST",
        headers: {"Accept": "application/json" },
        credentials : 'include' as RequestCredentials,
        body: payload,
    };

    return fetch(`${ApiConfigs.base_url + ApiConfigs.category.batchRank}`, requestOptions)
        .then(
            handleResponse
        );

    
}




function handleResponse(response: any) {
    if (!response.ok) {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            localStorage.removeItem("user");
            location.reload();
        }
        const error = (response && response.message) || response.status || response.statusText;
        return Promise.reject(error);
    }
    return response.json().then((rep: any) => {
        return rep;
    });
}